import React from 'react';
import PropTypes from 'prop-types';
import ProductListItem from './components/ProductListItem';

const ProductList = ({ products, matches, onSelectMatch }) => {
  return (
    <div className="grid w-full h-full">
      <div className="mb-5">
        {products?.map(product => (
          <ProductListItem
            key={product.productId}
            product={product}
            matchedProduct={matches.find(
              m => m.agrianEntityId === product.productId
            )}
            handleSelect={cwfSelectedProduct =>
              onSelectMatch(product, cwfSelectedProduct)
            }
          />
        ))}
      </div>
    </div>
  );
};

ProductList.defaultProps = {
  matches: []
};

ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
      productName: PropTypes.string
    })
  ).isRequired,
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
      productName: PropTypes.string
    })
  ),
  onSelectMatch: PropTypes.func.isRequired
};

export default ProductList;
